var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBarChart = function SvgBarChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 11.333c.46 0 .833.373.833.834v5a.833.833 0 0 1-1.666 0v-5c0-.46.373-.834.833-.834M15 8c.46 0 .833.373.833.833v8.334a.833.833 0 0 1-1.667 0V8.833c0-.46.374-.833.834-.833M10 3c.46 0 .833.373.833.833v13.334a.833.833 0 0 1-1.667 0V3.833c0-.46.374-.833.834-.833",
    clipRule: "evenodd"
  })));
};
export default SvgBarChart;